<template>
  <div class="video">
    <div class="video-cover" :style="{ backgroundImage: 'url(' + $setPicSize(video.picUrl) + ')' }" @click="showVideo(selectedIndex)">
      <z-icon class="video-cover-start" name="play-circle" size="0.42rem" color="#f0f0f0"/>
    </div>
    <div class="video-bottom">
      <span class="video-bottom-text">{{video.title}}</span>
      <div class="video-bottom-count">
        <z-icon class="video-bottom-count-icon" name="eye" />
        <!-- <z-image class="video-bottom-count-img" src="0b01581e-deda-4171-b92c-d78a1c3f0b6b.png" /> -->
        <span>{{video.playCount}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon, Toast } from '@zz-common/zz-ui'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'

export default {
  name: 'VideoComp',
  props: {
    video: Object,
    videoList: Array,
    selectedIndex: Number
  },
  data() {
    return {
      scrollEvents: ['scroll-end']
    }
  },
  components: {
    zIcon: Icon
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 400, 400)
    },
    showVideo(selectedIndex) {
      if (native.client !== 'zz') return Toast('请在转转端内查看')
      const per = new Date().getTime();
      lego.send({
        pagetype: 'ZZUP_SAFECENTER_VIDEO',
        actiontype: 'CLICK_COUNT',
        backup: {
          videoUrl: this.videoList[selectedIndex].videoUrl || 'unknow' //1 赔付说明 3我的记录 4 防骗测试
        }
      })
      native.wrap('enlargeImgsOrVideo')({
        videoVos: this.videoList,
        imgUrls: '',
        selectedIndex
      }, () => {
        const cur = new Date().getTime();
        console.log('time', cur - per);
        lego.send({
          pagetype: 'ZZUP_SAFECENTER_VIDEO',
          actiontype: 'CLICK_COUNT',
          backup: {
            videoUrl: this.videoList[selectedIndex].videoUrl || 'unknow',
            time: cur - per
          }
        });
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>